
/* Cart helpers. Preorder lines (all screen sizes) plus mobile simplification (see giorgio-cart-mobile.css).
- "Finish the look": adds a "Choose size" button that reveals the size menus and Add button.
- Wedding party code: collapses to one "Add your party code" line that opens on tap.
- Drops the trailing " USD" from cart totals on phones.
The bag re-renders after every change, so this re-applies itself whenever the cart markup changes. */
(() => {
const phone = window.matchMedia('(max-width: 749px)');
let uid = 0;

const enhancePairs = (root) => {
root.querySelectorAll('.g-pair__item').forEach((item) => {
if (item.querySelector('.g-pair__choose')) return;
const fields = item.querySelector('.g-pair__fields');
const add = item.querySelector('.g-pair__add');
if (!fields || !add) return;
fields.id = fields.id || `GiorgioPairFields-${++uid}`;
const btn = document.createElement('button');
btn.type = 'button';
btn.className = 'g-pair__choose';
btn.textContent = 'Choose size';
const name = item.querySelector('.g-pair__name')?.textContent.trim();
if (name) btn.setAttribute('aria-label', `Choose size — ${name}`);
btn.setAttribute('aria-expanded', 'false');
btn.setAttribute('aria-controls', fields.id);
btn.addEventListener('click', () => {
item.classList.add('is-open');
btn.setAttribute('aria-expanded', 'true');
fields.querySelector('select')?.focus();
});
add.before(btn);
});
};

const enhanceCode = (root) => {
root.querySelectorAll('.g-pair__wedding').forEach((box) => {
if (box.querySelector('.g-code__toggle')) return;
const form = box.querySelector('.g-code');
if (!form) return;
form.id = form.id || `GiorgioPartyCode-${++uid}`;
const btn = document.createElement('button');
btn.type = 'button';
btn.className = 'g-code__toggle';
btn.innerHTML = '<strong>In a wedding party?</strong> <span>Add your party code</span>';
btn.setAttribute('aria-expanded', 'false');
btn.setAttribute('aria-controls', form.id);
btn.addEventListener('click', () => {
box.classList.add('is-open');
btn.setAttribute('aria-expanded', 'true');
box.querySelector('[data-g-code-input]')?.focus();
});
box.prepend(btn);
});
};

const stripCurrency = (root) => {
if (!phone.matches) return;
root.querySelectorAll('.cart__total__price, .ms_get_total, .ms_append_total').forEach((el) => {
if (el.children.length) return;
const text = el.textContent;
if (/\sUSD\s*$/.test(text)) el.textContent = text.replace(/\s*USD\s*$/, '');
});
};

// All screen sizes: a preorder line shows one clear "Preorder · Ships by …" line instead of the three raw
// properties (Order type, Estimated shipping, Shipping acknowledgement). The properties still go to checkout.
const preorderStyle = () => {
if (document.getElementById('GiorgioCartPreorderStyle')) return;
const style = document.createElement('style');
style.id = 'GiorgioCartPreorderStyle';
style.textContent = '.g-cart-preorder-line{display:block;margin:4px 0 0;font-size:13px;line-height:1.4;color:#6b4f12}'
+ '.g-cart-preorder-line strong{display:inline-block;margin-right:6px;padding:1px 6px;border:1px solid #c9a24a;background:#fbf5e6;color:#6b4f12!important;font-size:11px;font-weight:600!important;letter-spacing:.06em;text-transform:none}'
+ '.cart__item__property[data-g-preorder-hidden]{display:none!important}';
document.head.append(style);
};
const tidyPreorder = (root) => {
root.querySelectorAll('.cart__item__meta').forEach((meta) => {
if (meta.querySelector('.g-cart-preorder-line')) return;
const rows = [...meta.querySelectorAll('.cart__item__property')];
const field = (name) => rows.find((row) => row.querySelector('strong')?.textContent.trim().replace(/:$/, '') === name);
const type = field('Order type');
if (!type || !/preorder/i.test(type.querySelector('span')?.textContent || '')) return;
const ship = field('Estimated shipping');
const ack = field('Shipping acknowledgement');
const when = ship?.querySelector('span')?.textContent.trim();
preorderStyle();
const line = document.createElement('span');
line.className = 'g-cart-preorder-line';
const badge = document.createElement('strong');
badge.textContent = 'Preorder';
line.append(badge, document.createTextNode(when ? `Ships ${when}` : 'Ships on the date shown at checkout'));
[type, ship, ack].forEach((row) => row?.setAttribute('data-g-preorder-hidden', ''));
meta.append(line);
});
};

const enhanceLook = (root) => {
root.querySelectorAll('#cart-drawer .g-pair').forEach((pair) => {
if (pair.querySelector('.g-pair__disclosure')) return;
const title = pair.querySelector('.g-pair__title');
const list = pair.querySelector('.g-pair__list');
if (!title || !list) return;
const lead = pair.querySelector('.g-pair__lead');
const details = document.createElement('details');
details.className = 'g-pair__disclosure';
const summary = document.createElement('summary');
pair.insertBefore(details, title);
summary.append(title);
details.append(summary);
if (lead) details.append(lead);
details.append(list);
});
};

const run = () => {
enhanceLook(document);
tidyPreorder(document);
enhancePairs(document);
enhanceCode(document);
stripCurrency(document);
};

let queued = false;
const schedule = () => {
if (queued) return;
queued = true;
// setTimeout, not requestAnimationFrame: animation frames pause while a page isn't painting, which left the
// bag un-tidied after an add-to-cart in that state.
setTimeout(() => { queued = false; run(); }, 30);
};

const start = () => {
run();
new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
else start();
})();
